<style type="text/css">
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        font-family: 'NotoKrD','NanumSquare',Dotum,sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

</style>

<template>
    <div>
        <div class="modal-mask"
             v-if="info.se === 'modal'||info.se === 'modalBlank'"
             :style="{'z-index':9990 + index}">
            <div class="modal-wrapper">
                <div class="modal-container"
                     ref="popContent"
                     style="position: absolute"
                     :style="setStyle"
                     v-dragged="info.draggableAt?onDragged:offDragged">
                    <div id="layer-wrap"
                         :style="{'border':0,'width':info.wid+'px','height':info.hei != ''?'' :info.hei+'px'}">
                        <div class="layer-header"
                             v-if="info.se === 'modal'"
                             @mousedown="mdown()"
                             @mouseleave="mleave()">
                            <h1>{{info.tit}}</h1>
                        </div>
                        <div style="height: calc(100% - 47px);"
                             @mouseover="mover()"
                             @mouseout="mout()">
                            <component v-bind:is="info.id" :index="index" :param="info.param"></component>
                        </div>
                        <div class="layer-footer"
                             v-if="info.se === 'modal'">
                            <button class="close" @click="close()">
                                <div class="img-com __del01">
                                    <span>닫기</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="info.se === 'layer'||info.se === 'layerBlank'"
             style="position: absolute"
             :style="setStyle"
             v-dragged="info.draggableAt?onDragged:offDragged">
            <div id="layer-wrap"
                 ref="popContent"
                 :style="{'border':0,'width':info.wid+'px','height':info.hei != ''?'' :info.hei+'px'}">
                <div class="layer-header"
                     v-if="info.se === 'layer'"
                     @mousedown="mdown()"
                     @mouseleave="mleave()">
                    <h1>{{info.tit}}</h1>
                </div>
                <div style="height: calc(100% - 47px);"
                     @mouseover="mover()"
                     @mouseout="mout()">
                    <component v-bind:is="info.id" :index="index" :param="info.param"></component>
                </div>
                <div class="layer-footer"
                     v-if="info.se === 'layer'">
                    <button class="close" @click="close()">
                        <div class="img-com __del01">
                            <span>닫기</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'popupContent',
        props:["info","index"],
        data : function(){
            return {
                showAt:false,
                top:0+'px',
                left:0+'px',
                setInfo:{
                    offsetX:0,
                    offsetY:0,
                    clientX:0,
                    clientY:0
                },
                contentChkInterval: null,
                clientHei:0,
                draggableAt:false,
                moverAt: false
            }
        },
        methods: {
            calTopLeft:function (wid,hei){
                var left = 0;
                var top  = 0;

                var winWid = window.innerWidth;
                var winHei = window.innerHeight;

                var windTop = document.body.scrollTop;

                var chkLeft = (winWid - wid)/2;
                var chkTop  = (winHei - hei)/2;

                chkLeft = Math.floor(chkLeft);
                chkTop  = Math.floor(chkTop);

                if(chkLeft > 0) left = chkLeft;
                if(chkTop  > 0) top  = chkTop + windTop;

                this.top  = top + 'px';
                this.left = left + 'px';
            },
            onDragged: function({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last }) {
                if(this.moverAt) return false;

                this.setInfo.offsetX = offsetX;
                this.setInfo.offsetY = offsetY;
                this.setInfo.clientX = clientX;
                this.setInfo.clientY = clientY;

                if (first) {
                    this.dragged = true
                    return
                }
                if (last) {
                    this.dragged = false
                    return
                }
                var l = +window.getComputedStyle(el)['left'].slice(0, -2) || 0
                var t = +window.getComputedStyle(el)['top'].slice(0, -2) || 0
                el.style.left = l + deltaX + 'px'
                el.style.top = t + deltaY + 'px'
            },
            offDragged: function() {

            },
            close:function(){
                this.$store.commit('closePopup',this.index);
            },
            getContentHei: function(){
                return this.$refs.popContent.offsetHeight;
            },
            mover: function(){
                if(this.info.se.indexOf('Blank') > -1) this.moverAt = true;
            },
            mout: function(){
                if(this.info.se.indexOf('Blank') > -1) this.moverAt = false;
            },
            mdown: function(){
                this.moverAt = false;
            },
            mleave: function(){
                this.moverAt = true;
            }
        },
        computed: {
            setStyle: function(){
                var style = {};
                if(this.info.se == "modal"||this.info.se == "modalBlank"){
                    style = {
                        'border':0,
                        'width':this.info.wid+'px',
                        'top':this.top,
                        'left':this.left,
                        'position':this.draggableAt?'absolute':''
                    };

                    if(this.info.hei != ''){
                        style['height'] = this.info.hei +'px';
                    }
                }else if(this.info.se == "layer"||this.info.se == "layerBlank"){
                    var hei = this.info.hei;

                    if(this.info.se == "layer"){
                        hei = Number(hei) + 47;
                    }

                    style = {
                        'background-color':'#fff',
                        'border': '1px solid #e0e0e0',
                        'z-index':9990 + this.index,
                        'width':this.info.wid+'px',
                        'top':this.top,
                        'left':this.left,
                    };


                    if(this.info.hei != ''){
                        style['height'] = (Number(hei)+1) +'px';
                    }
                }

                return style;
            },
        },
        mounted: function(){
            this.$nextTick(function(){
                const _this = this;
                let compCnt = 0;

                this.top  = 'calc( 50% - 47px )';
                if(typeof this.info.hei != 'undefined'&&this.info.hei != null){
                    if(this.info.hei == ''||this.info.hei == 0){
                        this.top = 'calc( 50% - ' + (Number(this.$refs.popContent.offsetHeight)/2) + 'px )';
                    }
                }

                this.left = 'calc( 50% - ' + (Number(this.info.wid)/2) + 'px )';

                this.contentChkInterval = setInterval(function(){
                    try{
                        if(_this.clientHei != _this.$refs.popContent.offsetHeight){
                            _this.clientHei = _this.$refs.popContent.offsetHeight;
                        }else{
                            compCnt++;
                            _this.showAt = true;
                            _this.calTopLeft(_this.info.wid,_this.clientHei);

                            if(compCnt == 10){
                                _this.calTopLeft(_this.info.wid,_this.clientHei);
                                if(_this.info.draggableAt){
                                    _this.draggableAt = true;
                                }
                                clearInterval(_this.contentChkInterval);
                            }
                        }
                    }catch (e) {
                        clearInterval(_this.contentChkInterval);
                    }
                }, 100);
            })
        }
    }
</script>

<style scoped>

</style>